<script setup lang="ts">
defineProps<{ kind: "Act" | "Chapter" }>();
const emit = defineEmits<{ create: [name: string] }>();
</script>
<template>
  <div class="zw-timeline-create">
    <button type="button" @click="emit('create', '')">+ {{ kind }}</button>
  </div>
</template>
<style scoped>
.zw-timeline-create {
  position: relative;
  padding: 12px 0 24px calc(var(--timeline-axis) + 24px);
}
button {
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-size: 0.8125rem;
  padding: 4px 0;
  cursor: pointer;
}
button:hover,
button:focus-visible {
  color: var(--text);
}

button:disabled {
  color: var(--text-muted);
  opacity: 1;
  cursor: default;
}
</style>
